
// TODO, このクラスファイルごと削除予定
import { Component, Vue } from 'vue-property-decorator';
import EnvRepository from '@/repository/EnvRepository';

@Component
export default class DebugHeaderComponent extends Vue {
  debugSessionId = '';

  get cookieName(): string {
    return EnvRepository.getEnv().VUE_APP_SSO_COOKIE_NAME;
  }

  addId(): void {
    this.$cookies.set(this.cookieName, this.debugSessionId);
  }

  removeId(): void {
    this.$cookies.remove(this.cookieName);
  }
}
